module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'tables/base' && templateVars.config ?
				templateVars.config :
				{
	"fixedHead": true,
	"selectableRows": true,
	"selectableColumns": false
};